var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"loading abs-center"},[_c('div',{staticClass:"loading-img"}),(_vm.isLoading)?_c('div',{staticClass:"loading-progress",style:({width:_vm.loadPercent+'%'})}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }